import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { DataCounterButton, PausedBadge } from '@root/shared/ui-kit'

import type { ClassNameProps } from '@root/shared/react'
export const EXPLORE_PAIRS_HEIGHT = 450

type ExplorePairsHeadingProps = {
  heading: React.ReactNode
  paused?: boolean
  buffedCount?: number
  filter?: React.ReactNode
  sort?: React.ReactNode
  disabled?: boolean
} & ClassNameProps

export const ExplorePairsHeading: React.FC<ExplorePairsHeadingProps> = ({
  heading,
  paused,
  buffedCount = 0,
  filter,
  sort,
  disabled,
}) => {
  const { t } = useTranslation()
  const showNewPairsBadge = (paused ?? false) && buffedCount > 0

  return (
    <Root aria-disabled={disabled}>
      {heading}
      <SortAndFilter>
        {showNewPairsBadge ? (
          <NewPairsCounterButton
            counter={buffedCount}
            text={t('trade.table.new-pairs')}
          />
        ) : undefined}
        <PausedBadge paused={paused ?? false} variant="icon" />
        {sort}
        {filter}
      </SortAndFilter>
    </Root>
  )
}

const Root = styled.header`
  color: var(--text-12);

  display: grid;
  align-items: center;
  grid-template-columns: auto 1fr;
  gap: 6px;

  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  padding-inline: 16px;
  padding-block: 10px 0;
  height: 50px;

  &[aria-disabled='true'] {
    color: var(--text-6);

    svg {
      color: var(--text-6);
    }
  }
`

const SortAndFilter = styled.span`
  display: grid;

  grid-auto-flow: column;
  justify-items: end;
  justify-content: end;
  gap: 8px;
`

const NewPairsCounterButton = styled(DataCounterButton)`
  --button-radius-rounded: 6px;

  color: var(--warning-9);
  background: rgba(var(--warning-9-rgb), 0.25);
  border: none;
  box-shadow: none;
  backdrop-filter: none;

  display: flex;
  height: 20px;
  min-height: unset;
  padding: 1px 6px 1px 2px;
  align-items: center;
  gap: 2px;

  font-size: 11px;
  font-weight: 500;
  line-height: 12px;
  white-space: nowrap;

  transition:
    background 0.1s ease-in-out,
    color 0.1s ease-in-out;

  &:hover {
    background: rgba(var(--warning-9-rgb), 0.35);
    color: var(--warning-9);
  }

  & > span:first-child {
    display: inline-flex;
    align-items: center;
    flex: 0 0 auto;
  }

  & > span:first-child > span {
    background: var(--amberA-9);
    color: var(--text-1);

    box-sizing: border-box;
    margin: 2px;
    height: 13px;
    min-width: 14px;
    width: auto;
    padding: 2px;

    font-weight: 700;
    border-radius: 2px;
    font-size: 8px;
    line-height: 1;

    display: grid;
    place-items: center;
    transition: background 0.15s linear;
  }
`
